import { applyTransaction } from '@datorama/akita';
import type GlobalUI from './types';
import { query } from 'state/UI/query';
import store from 'state/UI/store';

export function toggleUIState<K extends keyof GlobalUI>(prop: K) {
   store.update((state) => ({ [prop]: !state[prop] }));
}

export function updateUIState<K extends keyof GlobalUI>(prop: K, value: GlobalUI[K]) {
   if (query.getValue()[prop] !== value) {
      store.update({ [prop]: value });
   }
}

export function batchUpdateUI<K extends keyof GlobalUI>(updates = [] as [K, GlobalUI[K]][]) {
   applyTransaction(() => {
      updates.forEach(([prop, value]: [K, GlobalUI[K]]) => prop && value && updateUIState(prop, value));
   });
}
